import { Slot } from "expo-router";
import { View } from "react-native";
import { useTheme } from "@/hooks/useTheme";

export default function Layout() {
  const { colors } = useTheme();

  return (
    <View
      style={{
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: colors.background,
      }}
    >
      <View
        style={{
          flex: 1,
          width: "100%",
          maxWidth: 800,
        }}
      >
        <Slot />
      </View>
    </View>
  );
}
